import React from "react";

const SeatRequestModal = React.lazy(() => import("components/Modals/SeatRequestModal"));
const MentorRatingModal = React.lazy(() => import("components/Modals/MentorRatingModal"));
const DashboardUpdateModal = React.lazy(() => import("components/Modals/DashboardUpdateModal"));
const ActivateAccountModal = React.lazy(() => import("components/Modals/ActivateAccountModal"));
const PaymentModal = React.lazy(() => import("components/Modals/PaymentModal"));
const IntegrityTrainingModal = React.lazy(
  () => import("components/mui-styled-components/Modals/IntegrityTrainingModal"),
);

const CloserDispositionModal = React.lazy(() => import("components/Modals/CloserDispositionModal"));
const InterstitialNotifications = React.lazy(() => import("./InterstitialNotifications"));

const PlatformModals = () => {
  return (
    <React.Suspense fallback={null}>
      <InterstitialNotifications />
      <SeatRequestModal />
      <CloserDispositionModal />
      <MentorRatingModal />
      <DashboardUpdateModal />
      <ActivateAccountModal />
      <PaymentModal />
      <IntegrityTrainingModal />
    </React.Suspense>
  );
};

export default PlatformModals;
